import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "nes.css/css/nes.css";
import "./index.css";
import "./crt.css";
import "./assets/animate.min.css";

ReactDOM.render(<App />, document.getElementById("root"));

